<script lang="ts" setup>
import { MoneyFormatter } from '@apps/main/new-desktop/core/components/formatters';

import type { Money } from '@libs/trip-planner-interfaces';

interface AccommodationPriceProps {
  price: Money;
}

const props = defineProps<AccommodationPriceProps>();
</script>

<template>
  <div class="accommodation-price">
    <MoneyFormatter
      :data="{
        minPrice: undefined,
        currency: props.price.currency,
        price: props.price.amount,
        showPlusMinusMark: true,
        color: 'color-neutral-70',
      }"
    />
  </div>
</template>

<style lang="scss" scoped>
.accommodation-price {
  @include font-label-m-bold;
  padding: var(--spacing-8) var(--spacing-12);
  border-radius: var(--spacing-8);
  line-height: var(--line-heights-14);
  background-color: transparent;
  color: var(--color-neutral-70);
}
</style>
